(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('PaymentSlipService', PaymentSlipService)

    /** @ngInject */
    function PaymentSlipService(HttpService) {
        const PaymentSlipService = {
            getByParameters,
            get,
            getNotImported,
            getConfirmationNotImported,
            getPaymentStatusText,
            getPaymentStatusClass,
            importSlips,
            importConfirmations,
            changePaidStatus,
            delete: deletePaymentSlip
        }

        return PaymentSlipService;

        function getByParameters(params) {
            return HttpService.get('/payment/slips/by-parameters', {
                params
            });
        }

        function get(paymentSlipId) {
            return HttpService.get(`/payment/slips/${paymentSlipId}`);
        }

        function getNotImported(paymentRemittanceId) {
            return HttpService.get(`/payment/slips/${paymentRemittanceId}/not-imported`);
        }

        function getConfirmationNotImported(paymentConfirmationRemittanceId) {
            return HttpService.get(`/payment/slips/${paymentConfirmationRemittanceId}/not-imported-confirmation`);
        }

        function getPaymentStatusText(paymentSlip) {
            if (paymentSlip.Deleted)
                return 'DELETADO';

            if (paymentSlip.PaymentConfirmation && paymentSlip.PaymentConfirmation.Id)
                return 'PAGO';

            const momentDate = moment(paymentSlip.PaymentDueDate);

            if (!paymentSlip.Deleted && !paymentSlip.PaymentConfirmation && moment().isAfter(momentDate))
                return 'VENCIDO';

            if (!paymentSlip.Deleted && !paymentSlip.PaymentConfirmation)
                return 'EM ABERTO';
        }

        function getPaymentStatusClass(paymentSlip) {
            let response = {};

            if (paymentSlip.Deleted) {
                response['text-danger'] = true;
                return response;
            }

            if (paymentSlip.PaymentConfirmation && paymentSlip.PaymentConfirmation.Id) {
                response['text-success'] = true;
                return response;
            }

            const momentDate = moment(paymentSlip.PaymentDueDate);

            if (!paymentSlip.Deleted && !paymentSlip.PaymentConfirmation && moment().isAfter(momentDate)) {
                response['text-danger'] = true;
                return response;
            }


            if (!paymentSlip.Deleted && !paymentSlip.PaymentConfirmation) {
                response['text-info'] = true;
                return response;
            }
        }

        function importSlips(paymentRemittanceId) {
            return HttpService.get(`/payment/slips/import-from-remittance/${paymentRemittanceId}`);
        }

        function importConfirmations(paymentConfirmationRemittanceId) {
            return HttpService.get(`/payment/slips/import-from-confirmation/${paymentConfirmationRemittanceId}`);
        }

        function changePaidStatus(paymentSlipId, isPaid) {
            return HttpService.put(`/payment/slips/${paymentSlipId}/change-paid-status/${isPaid}`);
        }

        function deletePaymentSlip(paymentSlipId) {
            return HttpService.delete(`/payment/slips/${paymentSlipId}`);
        }
    }
}());